import _BaseAPIService from "../../_BaseAPIService";

 const apiService = _BaseAPIService.instance;
 const slug = "api";
 const DiscountService = {
    getList: async () =>{
        const response = await apiService.get(`/${slug}/discount`);
        return response.data;
    },
    create: async ({ data }) => {
        const response = await apiService.post(`/${slug}/discount`, data);
        return response.data;
      },
    detail: async (id) => {
        const response = await apiService.get(`/${slug}/discount/${id}`);
        return response.data;
    },
    delete: async (id) => {
        const response = await apiService.delete(`/${slug}/discount/${id}`);
        return response.data;
    },
    // update: async (id, updatedData) => {
    //     try {
    //         console.log('Sending request with data:', updatedData);
    //         const response = await apiService.put(`/${slug}/discount/${id}`, updatedData);
    //         return response.data;
    //     } catch (error) {
    //         console.error("Error updating discount:", error);
    //         throw error;
    //     }
    // }
    update: async (id, updatedData) => {
        try {
            console.log('Sending request with data:', updatedData);
            const response = await apiService.put(`/${slug}/discount?id=${id}`, updatedData);
            return response.data;
        } catch (error) {
            console.error("Error updating discount:", error);
            throw error;
        }
    },
    toggleStatus: async (id, isActive) => {
        try {
            const response = await apiService.put(`/${slug}/discount/${id}`, { isActive });
            return response.data;
        } catch (error) {
            console.error("Error toggling discount status:", error);
            throw error;
        }
    }
 }

 export default DiscountService;